import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import axios from "axios";
import { API, formatApiError } from "../lib/api";
import { CakeMark } from "../components/Logo";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, form);
      localStorage.setItem("velvet_admin_token", res.data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err, "Login failed. Check your details."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1C1417] flex items-center justify-center p-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md bg-[#281D22] border border-[#B87D8E]/20 rounded-3xl p-10"
      >
        <div className="flex flex-col items-center text-center mb-10">
          <CakeMark className="w-12 h-12" />
          <h1 className="font-serif text-3xl text-[#F9F6F0] mt-4">Velvet Bakes Studio</h1>
          <p className="text-xs uppercase tracking-[0.3em] text-[#B87D8E] mt-2">Owner sign in</p>
        </div>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-[#B87D8E] mb-2">Email</label>
            <input
              className="field-dark"
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="you@velvetbakes"
              data-testid="admin-login-email-input"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.2em] text-[#B87D8E] mb-2">Password</label>
            <input
              className="field-dark"
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="••••••••"
              data-testid="admin-login-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-button"
            className="w-full py-4 rounded-full bg-[#8B5D6C] text-[#F9F6F0] text-sm font-medium tracking-wide border border-[#C5A059]/60 hover:bg-[#4A2834] disabled:opacity-60 transition-colors"
          >
            {loading ? "Signing in…" : "Enter the studio"}
          </button>
        </form>
        <a href="/" data-testid="admin-back-to-site" className="block text-center mt-8 text-xs text-[#F9F6F0]/40 hover:text-[#C5A059] transition-colors">
          ← Back to velvetbakes
        </a>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
